import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-empty-state',
    imports: [],
    templateUrl: './empty-state.component.html',
    styleUrl: './empty-state.component.scss'
})
export class EmptyStateComponent {
    @Input() message = 'No records found.';
}
